module.exports = __webpack_public_path__ + "front/img/d13.0220a2ff.png";